module.exports = __webpack_public_path__ + "static/media/icon-anchor-fm.b865081a.svg";